export enum BLOCKER_ID {
  EJEMPLO_BLOCKER = 1,
  EJEMPLO_BLOCKER_SEGUNDO,
}
